import {useNavigate} from 'react-router-dom';
import DefaultImage from '../../../../../../../assets/image/newShop/defaultImg.png';
import Button from '../../../../../../../components/button';
import SpinnerLoading from '../../../../../../../components/SpinnerLoading';
import usePostExtend from '../../../../../../../services/hookService/postExtend/usePostExtendAdvertisement';
import convertToExpireDate from '../../../../../../../utilities/helper/convertToExpireDate';
import {getPersianDateTimeV2} from '../../../../../../../utilities/helper/GetPersianDateTime';
import InfoRow from '../../../../../../shopping-basket/ItemCard/InfoRow';

const ExpiredAdvertisementCard = ({storeAd}: {storeAd: IGetMyStoreAdsData}) => {
  const navigate = useNavigate();

  const imageSrc =
    storeAd?.main_image?.image ??
    storeAd?.main_image?.image_128 ??
    storeAd?.sub_brand_main_image?.image ??
    DefaultImage;

  const expireDate = storeAd?.published_date
    ? getPersianDateTimeV2(convertToExpireDate(storeAd?.published_date)) ??
      'مشخص نشده'
    : 'مشخص نشده';

  const {mutate: extendAdvertisement, isLoading} = usePostExtend();

  return (
    <div
      className="relative border-[1px] border-gray-300 shadow-sm shadow-gray-100 rounded-lg p-3 gap-3 flex flex-col text-md"
      onClick={() => {
        navigate(`/my-ads/advertisment/${storeAd?.id}`, {
          state: {
            type: 'advertisement',
            advertisement_type: storeAd?.advertisement_type,
          },
        });
      }}
    >
      <div className="flex gap-2">
        <img
          src={imageSrc}
          alt="عکس آگهی"
          className="rounded-lg size-[4.5rem]"
        />
        <div className="flex flex-col space-y-4 w-full min-w-0">
          <span className="block overflow-hidden mt-2 w-full min-w-0 font-medium whitespace-nowrap text-neutral-900 text-ellipsis line-clamp-1 max-w-48">
            {storeAd?.title}
          </span>
          <InfoRow
            icon="icon-nameCalendar  text-lg"
            valueClassName="text-blue-950 font-normal ext-md"
            label="تاریخ انقضا آگهی"
            value={expireDate}
            className="gap-2 pt-0 mt-2 w-fit"
          />
          <Button
            className="flex self-end gap-2 font-medium text-left text-farm-shop-500 rounded-lg transition-colors outline-none text-md !min-h-[32px] w-fit"
            size="small"
            onClick={e => {
              e.stopPropagation();
              extendAdvertisement({
                advertisement_id: storeAd?.id,
                type: 'advertisement',
              });
            }}
            disabled={isLoading}
          >
            {isLoading ? (
              <SpinnerLoading
                size={15}
                className=" flex justify-center items-center min-h-[2rem] w-14"
              />
            ) : (
              <span>تمدید آگهی</span>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ExpiredAdvertisementCard;
